import * as net from '~/lib/net';
import { Location, LocationFilter } from '../models';
import { LocationEndpoints, LocationEndpointsV2 } from './endpoints';
import * as schemas from './schemas';
import { getToken } from '~/apps/shared/services/token';


export async function getLocationById(locId: string): Promise<Location> {
  const data = await net.apiGet(LocationEndpoints.getLocationById(locId), getToken());
  return schemas.LocationSchema.load(data);
}

export async function getOrgLocations(orgId: string, filter: LocationFilter = null, offset = null, limit = null): Promise<Location[]> {
  const data = await net.apiGet(LocationEndpoints.getOrgLocations(orgId, filter, offset, limit), getToken());
  return schemas.LocationListSchema.load(data);
}

export async function findLocations(needle: string): Promise<Location[]> {
  const data = await net.apiGet(LocationEndpoints.findLocations(needle), getToken());
  return schemas.LocationListSchema.load(data);
}

export function createLocation(orgId: string, data) {
  throw new Error('Not implemented');
}

export function updateLocation(locationId: string, data) {
  throw new Error('Not implemented');
}


/**
 *  V2 version
 */

export async function getOrgLocationsV2(orgId: string, filter: LocationFilter = null, offset = null, limit = null): Promise<Location[]> {
  const data = await net.apiGet(LocationEndpointsV2.getOrgLocationsV2(orgId, filter, offset, limit), getToken());
  return schemas.LocationListSchema.load(data);
}
